/* eslint-disable @typescript-eslint/no-misused-promises */
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {Link, useSearchParams} from "react-router-dom";
import {Alert, Box, Grid, Paper, Stack, Typography} from "@mui/material";
import {useResourceManagement} from "../../hooks/resourceHooks";
import {verifyEmail} from "../../services/authenticationService";
import {swallowException} from "../../utils/appUtils";
import {getResourceErrorMessage, isResourceFailed, isResourceSucceeded} from "../../utils/resourceUtils";
import {AppLayout} from "../AppLayout";
import {EmptyHeader} from "../EmptyHeader";

export const VerifyEmailPage: React.FC = () => {
    const {t} = useTranslation();
    const {resource, verifyEmail: verify} = useResourceManagement({verifyEmail});
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const username = searchParams.get("username") ?? "";
        const code = searchParams.get("code") ?? "";
        void verify(username, code).catch(swallowException);
    }, [searchParams, verify]);

    return (
        <AppLayout header={<EmptyHeader />}>
            <Grid container component="main" display="flex" justifyContent="center" alignItems="center" height="100%">
                <Grid
                    item
                    component={Paper}
                    elevation={0}
                    square
                    sx={{
                        minWidth: "31.25rem",
                        width: "31.25rem",
                        borderRadius: "1rem",
                    }}
                >
                    {isResourceFailed(resource) && (
                        <Alert severity="error" sx={{paddingX: "2.5rem"}}>
                            {getResourceErrorMessage(resource)}
                        </Alert>
                    )}
                    {isResourceSucceeded(resource) && (
                        <Alert severity="success" sx={{paddingX: "2.5rem"}}>
                            {t("verify_email_page.success")}
                        </Alert>
                    )}
                    <Stack
                        direction="column"
                        justifyContent="center"
                        sx={{
                            paddingY: "2rem",
                            paddingX: "3rem",
                        }}
                    >
                        <Stack direction="column" alignItems="center">
                            <Typography component="h1" variant="h5" data-test="header">
                                {t("verify_email_page.title")}
                            </Typography>
                            <Box sx={{marginTop: "1rem", paddingX: "1.25rem", width: "100%"}}>
                                <Typography>{t("verify_email_page.verify")}</Typography>
                                <Link to={"/"}>{t("verify_email_page.go_to_login")}</Link>
                            </Box>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </AppLayout>
    );
};
